import React from 'react';
import { MeterScoreDemoChildProps } from './MeterScoreFullDemo';
import { Meter, Range } from '@ui';

export const MeterScoreNative: React.FC<MeterScoreDemoChildProps> = ({ value, setValue }) => {
  return (
    <>
      <Meter value={value} min={0} max={100} low={50} high={75} optimum={100} className='xmeter' />
      <Range
        id='rangeExample'
        outputId='rangeOut'
        value={value}
        min={0}
        max={100}
        step={1}
        onChange={setValue}
        aria-label='Adjust native meter value'
      />
    </>
  );
};
